import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import colors from '@/styles/colors';
import { checkEmpty } from '@/utils/commonFunctions';
import { CardContent, LangAndLabelBlock, RepoDescription, RepoLangDots, RepoLanguagesBlock, RepoLink } from '../styles';

export default function RenderCardContent({ contentData, type }) {
  const { name, url, languages, description } = contentData || {};
  return (
    <CardContent overFlow={type === 'list'} cardHeight="170px">
      <h1 className="title-font text-lg font-medium text-white mb-3">
        <RepoLink href={url} rel="noopener noreferer">
          {name}
        </RepoLink>
      </h1>
      {type === 'list' && description && (
        <RepoDescription className="leading-relaxed" data-tip={description} data-for="repo-description">
          {description?.length > 70 ? `${description.substr(0, 70)}...` : description}
        </RepoDescription>
      )}
      <ReactTooltip id="repo-description" type="info" multiline effect="solid" className="tooltip-description" offset={{ left: 10 }} />
      <RepoLanguagesBlock>
        {!checkEmpty(languages?.nodes) ? (
          languages?.nodes?.map(({ id, name: langName = '', color }) => (
            <LangAndLabelBlock key={id}>
              <RepoLangDots bgColor={color} />
              <span className="mr-2">{langName}</span>
            </LangAndLabelBlock>
          ))
        ) : (
          <LangAndLabelBlock key="other-lang">
            <RepoLangDots bgColor={colors.dark} />
            <span className="mr-2">Other</span>
          </LangAndLabelBlock>
        )}
      </RepoLanguagesBlock>
    </CardContent>
  );
}

RenderCardContent.propTypes = {
  contentData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  type: PropTypes.string.isRequired,
};
